import PropTypes from 'prop-types';
import React from 'react';
import isNull from 'lodash/isNull';
import ProgressBar from './progress-bar';
import Error from './error';

export default hasDataRenderComponent => props => {
	switch (true) {
		case uninitialized(props): return fetchData(props);
		case hasData(props): return hasDataRenderComponent(props);
		case hasError(props): return renderError(props);
		case shouldShowProgressBar(props): return renderProgressBar();
		default: throw new Error('Undefined state');
	}
};

// predicates
const uninitialized = props => !hasError(props) && isNull(props.data) && !shouldShowProgressBar(props);
const hasData = props => !hasError(props) && !isNull(props.data) && !shouldShowProgressBar(props);
const hasError = props => !!props.error && !shouldShowProgressBar(props);
const shouldShowProgressBar = props => props.progressBar;

// views
const fetchData = props => {
	// @todo Think about added possibility run initial config before build redux store
	// or reinitialize redux store use new initial config
	const shouldSetUserTimezone = props.calendarSetUserTimezoneDate;

	if (!shouldSetUserTimezone) {
		props.fetchData(props);
	} else {
		Promise.resolve()
			.then(() => props.calendarSetUserTimezoneDate())
			.then(isUserTimeZoneIsSet => {
				if (!isUserTimeZoneIsSet) return;
				props.fetchData(props);
			});
	}
	return <ProgressBar />;
};

fetchData.propTypes = {
	fetchData: PropTypes.func,
	calendarSetUserTimezoneDate: PropTypes.func
};

const renderError = props => <Error {...props} />;
const renderProgressBar = () => <ProgressBar />;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/render-views-state.js